// Google Fonts Api Key

export const fontsApiKey = 'AIzaSyDzUff3IBXiPPWNjjQyLX4h_VvuoeDqNys';
export const fontsApiUrl = 'https://www.googleapis.com/webfonts/v1/webfonts';
export const fontsApiCSSUrl = 'https://fonts.googleapis.com/css?family=';
